import React, { useState } from "react";
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import styled from "styled-components";
const Styles = styled.div`
  display: block;
  padding-left:0px;
   flex-direction: row; 
   /* min-width: 50%;  */
  .App {
  /* font-family: sans-serif;
  font-display:inherit; */
  text-align: left;
  flex-direction: row; 
}
 .button {
    top:0px;
    width:5px;
    height:20px;
    background-color:black;
    color:white;
 }
 .input{
    background-color:white;
    color:black;
    width:30px;
    height:20px;
 }

`
export default function Mytest() {

  const [count, setCount] = useState(0); // useState returns a pair. 'count' is the current state. 'setCount' is a function we can use to update the state.

  function increment() {
    //setCount(prevCount => prevCount+=1);
    setCount(function (prevCount) {
      return (prevCount += 1);
    });
  }

  function decrement() {
    setCount(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1); 
      } else {
        return (prevCount = 0);
      }
    });
  }

  return (
    <Styles   >
    <div className="App">
    <ButtonGroup>
    <Button className= "button" onClick={increment}>+</Button>
    <input className="input" value={count}></input>
    <Button  className= "button" onClick={decrement}>-</Button> 
   </ButtonGroup>
      {/* <button className= "button" onClick={increment}>+</button>
        <input className="input" value={count}></input>
      <button className="button" onClick={decrement}>-</button> */}
    </div>
    </Styles> 
  );
}
